<template>
  <Modal
    :show="show"
    @close-modal="$emit('close-api-modal')"
    class="api-client__modal"
  >
    <div class="lg:tw-flex">
      <img
        class="tw-hidden lg:tw-block"
        src="https://res.cloudinary.com/djalafcj9/image/upload/v1648818243/getequityV2/investor/api-client_poxlzr.png"
        alt="api client"
      />
      <div class="tw-pt-4 tw-pb-8 md:tw-py-8 api-client-content__div">
        <h1 class="tw-font-bold tw-text-2xl tw-text-secondary tw-mb-6">
          Introducing GetEquity {{ product.name }}
        </h1>
        <p class="tw-text-gray-dark2">
          {{ product.summary }}
        </p>
        <div
          class="tw-flex tw-flex-wrap tw-mt-8 tw-gap-y-4 md:tw-justify-center md:tw-gap-4 lg:tw-justify-start"
        >
          <div class="api-client__button--blue tw-w-full tw-relative">
            <div 
              v-if="!hasPermission" 
              class="tooltip"
            >
              You don't have permission to use this feature
            </div>
            <CustomButton
              :title="'Turn on ' + product.name"
              :loading="loading"
              :disabled="!hasPermission"
              @click="$emit('subscribe-to-service', product.category)"
              class="tw-w-full"
            />
          </div>
          <button
            class="api-client__button tw-rounded tw-bg-black-light3 tw-text-secondary tw-py-3 tw-px-4 tw-text-base tw-w-full tw-block"
            @click="$emit('close-api-modal')"
          >
            No, Thank you!
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../general/Modal";
import CustomButton from "../general/BtnComponent";
import { mapGetters } from "vuex";
import { permissionsService } from "@/utils/permissionChecker.js";

export default {
  name: "ProductsModal",
  emits: ["close-api-modal", "subscribe-to-service"],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  components: {
    Modal,
    CustomButton,
  },
  computed: {
    ...mapGetters(["loading"]),
    
    hasPermission() {
      const permissionMap = {
        'PUBLIC_RAISE': 'deal:*',
        'PRIVATE_RAISE': 'deal:*',
        'ESOP': 'deal:*',
        'API_KEY': 'api:*',
        'CREDIT': 'credit:*',
        'INVEST': 'invest:*',
      };
      
      const requiredPermission = permissionMap[this.product.category];
      return this.canPerformAction(requiredPermission);
    }
  },
  methods: {
    canPerformAction(action) {
      return permissionsService.hasPermission(action);
    }
  }
};
</script>

<style lang="scss" scoped>
.no-scroll {
  height: 100vh;
  overflow-y: hidden;
}
.api-client {
  &-content {
    &__div {
      @media (min-width: 1024px) {
        width: 540px;
        padding: 30px 60px;
      }
    }
  }
  &__button {
    @media (min-width: 1023px) {
      &--blue {
        max-width: 192px;
      }
      max-width: 154px;
    }
  }
}

.tooltip {
  position: absolute;
  z-index: 10;
  bottom: 100%;
  margin-bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1f2937;
  color: #ffffff;
  padding: 0.25rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.875rem; 
  white-space: nowrap;

  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}

.api-client__button--blue:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

</style>
